import { z } from 'zod';
import { strictRemoteCodec } from "./remote-codec.js";
import { ReplayRecoveryDurationSchema, ReplayRecoveryViewSchema } from "./replay-recovery-types.js";
const agent = { name: 'agent', wire: 'agentId', source: 'lookup', lookup: 'agent',
    codec: strictRemoteCodec('@deepseek-ai/dsh-session/types#SessionId', z.string().min(1).max(256)) };
const contribution = {
    package: 'dsh-github-copilot',
    descriptors: [
        {
            id: 'dsh-github-copilot:githubCopilotReplayRecovery.get',
            namespace: 'githubCopilotReplayRecovery', service: 'githubCopilotReplayRecovery', method: 'get',
            invocation: { kind: 'direct' }, parameters: [agent],
            result: strictRemoteCodec('dsh-github-copilot#ReplayRecoveryView', ReplayRecoveryViewSchema),
        },
        {
            id: 'dsh-github-copilot:githubCopilotReplayRecovery.authorize',
            namespace: 'githubCopilotReplayRecovery', service: 'githubCopilotReplayRecovery', method: 'authorize',
            invocation: { kind: 'direct' }, parameters: [
                agent,
                { name: 'revision', wire: 'revision', source: 'json', codec: strictRemoteCodec('dsh-github-copilot#ReplayRecoveryRevision', z.string().uuid()) },
                { name: 'duration', wire: 'duration', source: 'json', codec: strictRemoteCodec('dsh-github-copilot#ReplayRecoveryDuration', ReplayRecoveryDurationSchema) },
            ],
            result: strictRemoteCodec('dsh-github-copilot#ReplayRecoveryView', ReplayRecoveryViewSchema),
        },
        {
            id: 'dsh-github-copilot:githubCopilotReplayRecovery.setEnabled',
            namespace: 'githubCopilotReplayRecovery', service: 'githubCopilotReplayRecovery', method: 'setEnabled',
            invocation: { kind: 'direct' }, parameters: [
                agent,
                { name: 'revision', wire: 'revision', source: 'json', codec: strictRemoteCodec('dsh-github-copilot#ReplayRecoveryRevision', z.string().uuid()) },
                { name: 'enabled', wire: 'enabled', source: 'json', codec: strictRemoteCodec('dsh-github-copilot#ReplayRecoveryEnabled', z.boolean()) },
            ],
            result: strictRemoteCodec('dsh-github-copilot#ReplayRecoveryView', ReplayRecoveryViewSchema),
        },
    ],
};
export default contribution;
//# sourceMappingURL=replay-recovery-remote.js.map